import Axios from "axios";
import { useCallback, useEffect, useState } from "react";

export interface StockPriceFeed {
  value: string | null;
  change: string | null;
  uptrend: boolean;
}

interface StockPriceFeeds {
  NYSE: StockPriceFeed;
}

export const useStockPriceFeed: () => StockPriceFeeds = () => {
  const [priceFeed, setPriceFeed] = useState<StockPriceFeeds>({
    NYSE: { value: null, change: null, uptrend: false },
  });

  const getPriceFeed: () => Promise<StockPriceFeeds> = useCallback(async () => {
    // https://investors.cnh.com/feed/StockQuote.svc/GetFullStockQuoteList?exchange=XNYS&symbol=CNH&pageSize=1
    /** 
     * **** previous stock ticker link-- just in case! ****
     * https://charts3.equitystory.com/api-web/cnhindustrial-v31/English 
     */
    const { data } = await Axios.get(
      "https://investors.cnh.com//feed/StockQuote.svc/GetStockQuoteList",
      {
        params: {
          apiKey: 'BF185719B0464B3CB809D23926182246',
          exchange: 'XNYS',
          symbol: 'CNH'
        },

        headers: {
          'Accept': 'application/json',
          // 'x-q4-client-integration': 'e01c0f89-1404-4100-891f-1ac9ae44a31b'
        }
      }
    );

    const newPriceFeed: StockPriceFeeds = {
      NYSE: {
        value: `${data?.GetStockQuoteListResult[0]?.TradePrice} USD`,
        change: data?.GetStockQuoteListResult[0]?.PercChange,
        uptrend: parseFloat(data?.GetStockQuoteListResult[0]?.Change) >= 0,
      }
    };

    return newPriceFeed;
  }, []);

  useEffect(() => {
    getPriceFeed().then((priceFeed) => setPriceFeed(priceFeed));
  }, []);

  return priceFeed;
};
